import { render } from "./_Index.vue?vue&type=template&id=31c6a28c&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=31c6a28c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31c6a28c"

export default script